export const APP_RESIZE = "APP_RESIZE";
export const KEY_COLLECTION = "KEY_COLLECTION";
export const APP_KEYBOARD_ENABLED = "APP_KEYBOARD_ENABLED";
export const ADVANCED_SEARCH_ENABLED = "ADVANCED_SEARCH_ENABLED";
export const ADVANCED_SEARCH_VALUES_FROM_NAVBAR = "ADVANCED_SEARCH_VALUES_FROM_NAVBAR";
export const ASSET_TYPE = "ASSET_TYPE";
export const ADVANCED_SEARCH_VISIBLE = "ADVANCED_SEARCH_VISIBLE";
export const EDIT_MY_ACCOUNT_VISIBLE = "EDIT_MY_ACCOUNT_VISIBLE";
export const SELECTED_CP_ACTIVITY_LOG_VALUE = "SELECTED_CP_ACTIVITY_LOG_VALUE";
export const SELECTED_FOLDER_EXPLORE = "SELECTED_FOLDER_EXPLORE";
